import React, { memo } from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { isNil } from "ramda";

import { Text, View } from "../../../Base";
import { DeliveryIcon, LocationIcon, ParcelIcon } from "../../../icons";
import palette from "../../../styles/palette";

const useStyles = makeStyles(() => ({
  statRow: {
    display: "flex",
    paddingRight: "1.375rem",
  },
  statContainer: {
    flex: 1,
  },
  text: {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    color: palette.typography.white.high,
  },
  bold: {
    fontWeight: "bold",
    paddingLeft: "0.625rem",
  },
  icon: {
    width: "0.75rem",
    height: "0.75rem",
    marginLeft: "0.688rem",
    marginRight: "0.25rem",

    "& svg": {
      width: "0.75rem",
      height: "0.75rem",
      fill: palette.typography.white.medium,
      fillOpacity: 1,
    },
  },
}));

const StatsRow = ({
  statKey,
  label,
  route,
  labelClassName,
  totalCollectionStops,
}) => {
  const styles = useStyles();
  return (
    <View key={label} className={styles.statRow}>
      <Text
        className={clsx(styles.text, styles.bold, labelClassName)}
        data-testid={`label-${statKey}`}
      >
        {label}
      </Text>
      <View className={clsx(styles.statRow, styles.statContainer)}>
        <View className={styles.icon}>
          <ParcelIcon />
        </View>
        <Text
          className={clsx(styles.text, styles.value)}
          data-testid={`parcelStats-${statKey}`}
        >
          {`${
            Array.isArray(statKey)
              ? route[statKey[0]]
              : route.parcelStats[statKey]
          }`.padStart(3, 0)}
        </Text>
        <View className={styles.icon}>
          <LocationIcon />
        </View>
        <Text
          className={clsx(styles.text, styles.value)}
          data-testid={`stopStats-${statKey}`}
        >
          {`${
            Array.isArray(statKey)
              ? route[statKey[1]]
              : route.stopStats[statKey]
          }`.padStart(3, 0)}
        </Text>
        {!isNil(totalCollectionStops) && (
          <>
            <View className={styles.icon}>
              <DeliveryIcon />
            </View>
            <Text
              className={clsx(styles.text, styles.value)}
              data-testid="totalCollectionStops"
            >
              {`${totalCollectionStops}`.padStart(3, 0)}
            </Text>
          </>
        )}
      </View>
    </View>
  );
};

export default memo(StatsRow);
